// extracted by mini-css-extract-plugin
export default {"backButton":"BackButton_backButton__8FTis","arrowBackIcon":"BackButton_arrowBackIcon__u-1rB","materialGroup":"BackButton_materialGroup__Ljdp7","action":"BackButton_action__RJseb"};